<template>
    <div class="function-parameter">
        <div class="field">
            <label>{{$t("message.type")}}</label>
            <a-select v-model="clone.type" style="width: 100%">
                <a-select-option value="string">{{ $t("chatbotv2.paramTypeString") }}</a-select-option>
                <a-select-option value="number">{{ $t("chatbotv2.paramTypeNumber") }}</a-select-option>
                <a-select-option value="boolean">{{ $t("chatbotv2.paramTypeBoolean") }}</a-select-option>
            </a-select>
        </div>
        <div class="field">
            <label>{{ $t("message.name") }}</label>
            <input v-model="clone.name" />
        </div>
        <div class="field description">
            <label>{{ $t("message.description") }}</label>
            <input v-model="clone.description" />
        </div>

        <div class="field">
            <label>{{ $t("message.required") }}</label>
            <a-switch v-model="clone.required" />
        </div>
        <SupsisButton danger @click="$emit('delete')">
            <i class="material-icons">delete</i>
        </SupsisButton>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "FunctionParameter",
    components: { SupsisButton },
    props: {
        value: {
            type: Object,
            default: () => ({
                name: "product_name",
                description: "",
                type: "string",
                required: true,
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        value: {
            handler(value) {
                this.clone = _.cloneDeep(value);
            },
            deep: true,
        },
        clone: {
            handler(value) {
                const isChanged = !_.isEqual(value, this.value);
                if (isChanged) {
                    this.$emit("input", value);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.function-parameter {
    display: flex;
    gap: 10px;
    align-items: center;

    .field {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: baseline;

        label {
            color: #22272d;
            font-weight: 500;
        }

        input {
            padding: 5px;
            border: 1px solid #d9d9d9;
            border-radius: 5px;
            color: #22272d;
            width: 200px;
        }

        .ant-select {
            width: 150px;
        }

        &.description {
            width: 100%;

            input {
                width: 100%;
            }
        }
    }
}
</style>
